import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { DeviceSigningPayload, OtpRequiredResponse } from '@repo/user-types'

const initialDeviceSigningState: GenericOperationState<OtpRequiredResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: deviceSigningDataActions, reducer: deviceSigningDataReducer } =
  createOperationSlice<
    OtpRequiredResponse | null,
    SliceCaseReducers<GenericOperationState<OtpRequiredResponse | null>>,
    DeviceSigningPayload
  >({
    name: '@users/devices/signing',
    initialState: initialDeviceSigningState,
    reducers: {},
  })
